import { Component, inject, OnInit } from '@angular/core';
import { UserStateService } from '../../services/user-state.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-post-sign-in',
  templateUrl: './post-sign-in.component.html',
  styleUrls: ['./post-sign-in.component.scss'],
  imports: [MatProgressBarModule]
})
export class PostSignInComponent implements OnInit {

  private readonly userState = inject(UserStateService);

  ngOnInit(): void {
    const currentUrl = new URL(window.location.toString());

    if (!currentUrl.searchParams.has('code')) {
      this.userState.handleSignInFailure();
    } else {
      const authCode = currentUrl.searchParams.get('code') || '';
      this.userState.handleSignInSuccess(authCode);
    }
  }

}
